import { Eye, EyeOff } from 'lucide-react';
import * as React from 'react';
import { Input } from '@/shared/components/ui/input';
import type { InputProps } from '@/shared/components/ui/input';

type PasswordInputProps = Omit<InputProps, 'type'> & {
  'data-testid'?: string;
};

const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>((props, ref) => {
  const [showPassword, setShowPassword] = React.useState(false);
  const { 'data-testid': testId, ...rest } = props;

  const Icon = showPassword ? EyeOff : Eye;

  return (
    <Input
      {...rest}
      data-testid={testId}
      ref={ref}
      type={showPassword ? 'text' : 'password'}
      iconEnd={
        <button
          type="button"
          data-testid={testId ? `${testId}-toggle` : undefined}
          onClick={() => setShowPassword((prev) => !prev)}
          className="flex items-center text-primary cursor-pointer"
          aria-label={showPassword ? 'Ocultar contraseña' : 'Mostrar contraseña'}
        >
          <Icon className="w-5 h-5" />
        </button>
      }
    />
  );
});

PasswordInput.displayName = 'PasswordInput';

export { PasswordInput };
